import {RequireAuth} from 'react-auth-kit'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from 'src/_metronic/layout/MasterLayout'
import {PromoLayout} from 'src/_metronic/layout/PromoLayout'

import * as Page from 'src/feature'

const PrivateRoutes = () => {
  const loginPath = '/sign-in'

  return (
    <Routes>
      {/* <Route path='activate' element={<Page.ActivatePage />} /> */}
      <Route path='sign-in' element={<Page.SignIn />} />
      <Route path='create-password' element={<Page.CreatePassword />} />
      <Route path='new-password' element={<Page.NewPassword />} />
      <Route path='forgot-password' element={<Page.ForgotPassword />} />
      {/*    <Route path='become-a-merchant' element={<Page.BecomeMerchant />} />
      <Route path='become-a-merchant/retail' element={<Page.Retail />} /> */}
      <Route path='become-a-merchant/pricing' element={<Page.Pricing />} />
      <Route path='become-a-merchant/landing' element={<Page.Landing />} />
      <Route path='become-a-merchant/get-started' element={<Page.GetStarted />} />
      <Route path='become-a-merchant/merchant-form' element={<Page.MerchantForm />} />
      <Route path='become-a-merchant/merchant-form-2' element={<Page.MerchantForm2 />} />
      {/*   <Route path='become-a-merchant/success' element={<Page.PaymentSuccess />} /> */}

      <Route
        path='member-payment-package/:packageName/:paymentId'
        element={<Page.MemberPaymentPackageView />}
      />
      <Route path='member-payment-package/:paymentId' element={<Page.MemberPaymentPackageView />} />
      <Route path='member-payment/:packageName/:paymentId' element={<Page.MemberPaymentView />} />
      <Route path='member-payment/:paymentId' element={<Page.MemberPaymentView />} />

      <Route element={<MasterLayout />}>
        <Route
          path='dashboard'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Dashboard />
            </RequireAuth>
          }
        />
        <Route
          path='change-password'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Profile />
            </RequireAuth>
          }
        />
        <Route
          path='task-in-progress'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.TasksInProgress />
            </RequireAuth>
          }
        />
        <Route
          path='new-location/corporate'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.LocationCreateCorporate />
            </RequireAuth>
          }
        />
        <Route
          path='new-location/freelancer'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.LocationCreateFreelancer />
            </RequireAuth>
          }
        />
        <Route
          path='import-tasks'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ImportTasks />
            </RequireAuth>
          }
        />
        <Route
          path='members'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Members />
            </RequireAuth>
          }
        />
        {/*
        members/membership/:packageId --> packageId değerine sahip olan paketi (membership) satın almış olan tüm üyeleri listele
        */}
        <Route
          path='members/membership/:packageId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MembersByPackage />
            </RequireAuth>
          }
        />
        {/*
        members/membership/:packageId/:memberId --> packageId değerine sahip olan paketi (membership) satın almış olan ve memberId değerine sahip olan member'ın paket detayını göster
        */}
        <Route
          path='members/membership/:packageId/:memberId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.PackageDetailByMember />
            </RequireAuth>
          }
        />
        <Route
          path='members/product/:itemId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MembersByItem />
            </RequireAuth>
          }
        />
        <Route
          path='members/product/:itemId/:memberId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ItemDetailByMember />
            </RequireAuth>
          }
        />
        <Route
          path='members/:memberId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MemberDetail />
            </RequireAuth>
          }
        />
        <Route
          path='transaction/:transactionId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Transaction />
            </RequireAuth>
          }
        />
        <Route
          path='provider'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Provider />
            </RequireAuth>
          }
        />
        <Route
          path='statement'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Statement />
            </RequireAuth>
          }
        />
        <Route
          path='analytics'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Analytics />
            </RequireAuth>
          }
        />
        <Route
          path='stores'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.StoreHome />
            </RequireAuth>
          }
        />
        <Route
          path='transaction-list'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.TransactionsAll />
            </RequireAuth>
          }
        />
        <Route
          path='stores/:storeId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.StoreDetail />
            </RequireAuth>
          }
        />

        <Route
          path='users/:userID'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.UserDetail />
            </RequireAuth>
          }
        />
        <Route
          path='referral'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Referral />
            </RequireAuth>
          }
        />
        <Route
          path='terminals'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Terminal />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/:terminalId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.TerminalDetail />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/:terminalId/edit'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.EditTerminal />
            </RequireAuth>
          }
        />
        <Route
          path='terminals/new-terminal'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewTerminal />
            </RequireAuth>
          }
        />
        <Route
          path='vip/new-tier'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.NewVIPTier />
            </RequireAuth>
          }
        />
        <Route
          path='vip/edit/:tierId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.EditVIPTier />
            </RequireAuth>
          }
        />
        <Route
          path='vip'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.VIP />
            </RequireAuth>
          }
        />
        <Route
          path='packages'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.PackageHome />
            </RequireAuth>
          }
        />
        <Route
          path='packages/new-package'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewPackage />
            </RequireAuth>
          }
        />
        <Route
          path='packages/edit/:packageId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.PackageDetail />
            </RequireAuth>
          }
        />
        <Route
          path='packages/:packageId/send-payment-link'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.SendPaymentLinkPackage />
            </RequireAuth>
          }
        />
        <Route
          path='items'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ItemsHome />
            </RequireAuth>
          }
        />
        <Route
          path='items/:itemId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ItemsDetail />
            </RequireAuth>
          }
        />
        <Route
          path='items/:itemId/send-payment-link'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.SendPaymentLink />
            </RequireAuth>
          }
        />
        <Route
          path='items/new-item'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewItems />
            </RequireAuth>
          }
        />
        <Route
          path='items/edit/:itemId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ItemsDetail />
            </RequireAuth>
          }
        />
        <Route
          path='products'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ProductHome />
            </RequireAuth>
          }
        />
        <Route
          path='products/new-product'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.AddNewProduct />
            </RequireAuth>
          }
        />
        <Route
          path='products/:productId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.ProductDetail />
            </RequireAuth>
          }
        />
        <Route
          path='market-place'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlace />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/:productId'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceDetail />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/success'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceSuccess />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/cart'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceCart />
            </RequireAuth>
          }
        />
        <Route
          path='market-place/checkout'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.MarketPlaceCheckout />
            </RequireAuth>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route element={<PromoLayout />}>
        <Route
          path='campaign'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Campaign />
            </RequireAuth>
          }
        />
        <Route
          path='engagement'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Engagement />
            </RequireAuth>
          }
        />
        <Route
          path='help'
          element={
            <RequireAuth loginPath={loginPath}>
              <Page.Help />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
